import React, { useEffect, useState } from 'react'
import TopBar from '../Layouts/TopBar'
import Footer from '../Layouts/Footer'
import AllProperties from '../SubComponents/AllProperties'
import { useNavigate } from 'react-router-dom'
import axios from 'axios';
import Swal from 'sweetalert2'
import Suggested from "../SubComponents/Suggested"

const SuggestedProperties = () => {
  const navigate = useNavigate();
  const currentUser = JSON.parse(localStorage.getItem('user'))?.user;
  const token = localStorage.getItem('token');
  const base_url = 'https://api.homehive.co.zw';
  const [userLocation, setUserLocation] = useState(null);
  const [isLoadingLocation, setIsLoadingLocation] = useState(true);

  // Function to calculate distance between two coordinates using Haversine formula
  const calculateDistance = (lat1, lon1, lat2, lon2) => {
    const R = 6371; // Earth's radius in kilometers
    const dLat = toRad(lat2 - lat1);
    const dLon = toRad(lon2 - lon1);
    const a = 
      Math.sin(dLat/2) * Math.sin(dLat/2) +
      Math.cos(toRad(lat1)) * Math.cos(toRad(lat2)) * 
      Math.sin(dLon/2) * Math.sin(dLon/2);
    const c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1-a));
    const distance = R * c;
    return distance;
  };

  // Convert degrees to radians
  const toRad = (value) => {
    return value * Math.PI / 180;
  };

  // Get user's current location
  const getUserLocation = () => {
    setIsLoadingLocation(true);
    if ("geolocation" in navigator) {
      navigator.geolocation.getCurrentPosition(
        (position) => {
          setUserLocation({
            latitude: position.coords.latitude,
            longitude: position.coords.longitude
          });
          setIsLoadingLocation(false);
        },
        (error) => {
          console.error("Error getting location:", error);
          Swal.fire({
            title: 'Location Access Required',
            text: 'Please enable location access to see nearby properties',
            icon: 'warning',
            confirmButtonColor: '#075E54'
          });
          setIsLoadingLocation(false);
        },
        {
          enableHighAccuracy: true,
          timeout: 5000,
          maximumAge: 0
        }
      );
    } else {
      Swal.fire({
        title: 'Geolocation Not Supported',
        text: 'Your browser does not support geolocation',
        icon: 'error',
        confirmButtonColor: '#075E54'
      });
      setIsLoadingLocation(false);
    }
  };

  useEffect(() => {
    getUserLocation();
  }, []);

  const handleStartChat = async (propertyId, landlordId) => {
    if (!currentUser || !token) {
      Swal.fire({
        title: 'Login Required',
        text: 'Please login to chat with the landlord',
        icon: 'info',
        showCancelButton: true,
        confirmButtonColor: '#075E54',
        confirmButtonText: 'Login',
        cancelButtonText: 'Cancel'
      }).then((result) => {
        if (result.isConfirmed) {
          navigate('/login');
        }
      });
      return;
    }

    try {
      // First try to find existing conversation
      const response = await axios.get(
        `${base_url}/conversations/find/${propertyId}/`,
        { headers: { 'Authorization': `Bearer ${token}` } }
      );

      if (response.data?.id) {
        // Existing conversation found
        navigate(`/chat/${response.data.id}`);
      } else {
        // Create new conversation
        const newConversation = await axios.post(
          `${base_url}/conversations/`,
          {
            property_id: propertyId,
            landlord_id: landlordId
          },
          { headers: { 'Authorization': `Bearer ${token}` } }
        );

        navigate(`/chat/${newConversation.data.id}`);
      }
    } catch (error) {
      console.error('Error starting chat:', error);
      Swal.fire({
        title: 'Error',
        text: 'Failed to start chat. Please try again.',
        icon: 'error',
        confirmButtonColor: '#075E54'
      });
    }
  };

  // Filter properties by distance
  const filterPropertiesByDistance = (properties) => {
    if (!userLocation) return properties;

    return properties.filter(property => {
      if (!property.latitude || !property.longitude) return false;

      const distance = calculateDistance(
        userLocation.latitude,
        userLocation.longitude,
        property.latitude,
        property.longitude
      );

      return distance <= 20; // 20km radius
    });
  };

  return (
    <div>
      <TopBar/>
      {isLoadingLocation ? (
        <div className="location-loading">
          <div className="spinner-border text-primary" role="status">
            <span className="visually-hidden">Loading location...</span>
          </div>
          <p>Getting your location...</p>
        </div>
      ) : (
        <Suggested 
          onStartChat={handleStartChat} 
          userLocation={userLocation}
          filterPropertiesByDistance={filterPropertiesByDistance}
        />
      )}
      <Footer/>
    </div>
  )
}

export default SuggestedProperties;
